import type { ReactNode } from "react";
import { buttonClassName } from "../../components/Button/Button";
import styles from "./StatusPage.module.css";

interface StatusPageProps {
  /** Short status line, e.g. "Error 404". Shown above the title. */
  code?: string;
  title: string;
  children: ReactNode;
  /** Primary way out. Uses a plain anchor so it still works if the router itself failed. */
  action?: { href: string; label: string };
  /** Developer-only detail; callers pass it only in development builds. */
  details?: string;
}

/** Full-page status screen used by every error state (WEB-008). No router dependency. */
export function StatusPage({ code, title, children, action, details }: StatusPageProps) {
  return (
    <div className={styles.wrap}>
      <main className={styles.panel}>
        {code && <p className={styles.code}>{code}</p>}
        <h1 className={styles.title}>{title}</h1>
        <div className={styles.body}>{children}</div>
        {action && (
          <a className={buttonClassName("primary", styles.action)} href={action.href}>
            {action.label}
          </a>
        )}
        {details && (
          <details className={styles.details}>
            <summary>Technical details (development only)</summary>
            <pre>{details}</pre>
          </details>
        )}
      </main>
    </div>
  );
}
